module.exports = __webpack_public_path__ + "static/media/webPayPlus.c147fe48.png";